import image1 from '../../asserts/banner-wordpress.webp'
import image2 from '../../asserts/banner-react.webp'
import image3 from '../../asserts/banner-laravel.webp'
import image4 from '../../asserts/banner-mobile.webp'
import image5 from '../../asserts/UiUx.gif'
import image6 from '../../asserts/seo.gif'
import image7 from '../../asserts/social-media-marketing.webp'
import image8 from '../../asserts/content-writer.webp'

export const ServiceData = [
    {
        id:'1',
        image: image2, 
        title: "React Development" ,
        slug: "react-development" ,
        description: "Get fast, responsive and engaging web applications with our React Development Services. It will help your businesses to build high performance and interactive applications that will keep the users hooked." ,
        description2: "From a sleek single page app to a complex web platform, our digital marketing agency use React’s powerful ecosystem to create convenient solutions that will be both scalable and efficient.",
        tags: '',
        buttonLink: "" 
    },
    {
        id:'2',
        image: image3, 
        title: "Laravel Development" ,
        slug: "laravel-development" ,
        description: "Laravel is a top choice for you, when it comes to secure and scalable web applications. Our development team has the expertise in building custom web solutions. We use Laravel’s robust framework." ,
        description2: "The professionals ensure your site is fast, full of advanced features and is easy to manage. From e-commerce websites to enterprise applications, we design our solutions that will fit your business requirements.",
        tags: 'Laravel Libraries Tools',
        buttonLink: "" 
    },
    {
        id:'6',
        image: image6, 
        title: "Search Engine Optimization (SEO)" ,
        slug: "search-engine-optimization" ,
        description: "Getting found online on google search bar or other search engines isn't luck, it is a strategy that needs a lot of hard work. This is where EgeneusCo comes to assist you by offering the exceptional SEO Services." ,
        description2: "Our unique strategies will help your businesses to rank on search engines and attract the organic traffic that converts. With high keyword research, technical and semantic SEO, content optimization, our digital marketing expert make sure that your website is visible, valuable and ahead of the competition.",
        tags: 'GoogleAnalytics, Tag Manager, Search Console, Site Optimization',
        buttonLink: "" 
    },
    {
        id:'7',
        image: image7, 
        title: "Social Media Marketing (SMM)" ,
        slug: "socia-media-marketing" ,
        description: "Do you have an audience on social media…do you? Let’s make it a little more with our social media marketing services (SMM). it will help you connect, engage and grow your brand across platforms, like Facebook, Instagram, Linkedin, Twitter, and Shoutify etc." ,
        description2: "from content creation, ad campaign to community management, we cover all under one roof. EgeneusCo assists you making your positive impact where it matters.",
        tags: 'Social Platofrms, Social Bookmarking, Social Posting',
        buttonLink: "" 
    },
    {
        id:'8',
        image: image8, 
        title: "Content Writer" ,
        slug: "content-writer" ,
        description: "Words matter a lot to convey your ideas to others efficiently and in an understanding way. So, no matter if it is a website copy, blogs, marketing materials, or documentations, we offer exceptional and creative content writing services that will help you in enhancing your brand's voice." ,
        description2: "We promise to deliver engaging, persuasive, and SEO friendly content that speaks to your audience. We craft compelling stories that not only inform but also drive action. We write AI and Plagiarism free and well researched content that will benefit you. Why look for less when EgeneusCo is here to assist you in all the ways.",
        tags: 'Humanised content, Plagiarism free, 5% Ai',
        buttonLink: "" 
    },
    {
        id:'5',
        image: image5, 
        title: "UI/UX Designer" ,
        slug: "ui-ux-designer" ,
        description: "First impression of anything matters a lot and your digital presence should wow your audience. We make your physical appearance with the astonishing and stunning UI/UX design services at EgeneusCo." ,
        description2: "Our professional team focuses on creating intuitive, beautiful, and conversion driven designs. We create a user experience that not only appears great but also enhances the functionality. Our UI/UX designs ensure a smooth and enjoyable journey for every visitor.",
        tags: 'Figma, AdobePhotoshop',
        buttonLink: "" 
    },
    {
        id:'3',
        image: image4, 
        title: "MobileApp Development" ,
        slug: "mobileApp-development" ,
        description: "Got an idea for a mobile app? What are you waiting for? Let’s turn your concept into a fully functional, user friendly mobile application for both iOS and Android." ,
        description2: "From your business app requirement to a custom solution, our development team is diligent to create a seamless and engaging mobile experience that will be specifically designed for your business growth.",
        tags: 'Mobile VisualStudio Tools',
        buttonLink: "" 
    },
    {
        id:'4',
        image: image1, 
        title: "Wordpress Development" ,
        slug: "wordpress-development" ,
        description: "A great website isn’t just about the looks, it needs to perform. With our wordPress development services, we ensure you will get a stunning, SEO friendly and high-speed website that will be specifically designed to match your business preferences." ,
        description2: "From custom themes to advanced plugins, we build the wordpress solutions that are easy to manage and built to last.",
        tags: 'Elementor, Divi, Avada etc',
        buttonLink: "" 
    }
];